//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

module.exports = {
    FixedText: require('./FixedText'),
    shortTextView: require('./shortTextView'),
};


